import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";
import { fileDownload } from "../../util/fileManagement";
import { imgUrl } from "../../constants/url";

function FileImgPreview({
  fileName,
  serverFileName,
  imgStyle,
  isVideo,
  videoStyle,
}) {
  const navigate = useNavigate();
  return (
    <>
      <FileImgPreviewWrapper>
        {fileName ? (
          <>
            {isVideo ? (
              <video
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "3px",
                  objectFit: "cover",
                  ...videoStyle,
                }}
                src={imgUrl + serverFileName}
                muted
                playsInline
                controls={false} // 컨트롤 표시 안 함
                onClick={(e) => e.preventDefault()} // 클릭 시 재생 방지
              />
            ) : (
              <img
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "3px",
                  ...imgStyle,
                }}
                src={imgUrl + serverFileName}
                alt=""
              />
            )}

            <FileDownloadBtn
              onClick={() => {
                fileDownload(serverFileName, fileName);
              }}
            >
              <img src="/assets/admin/icons/ico_file_download.svg" alt="" />
              <PretendardText
                style={{
                  maxWidth: "300px",
                  overflow: "hidden",
                  fontSize: "16px",
                  fontWeight: "500",
                  letterSpacing: "-0.048px",
                  color: "#636c73",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {fileName}
              </PretendardText>
            </FileDownloadBtn>
          </>
        ) : (
          ""
        )}
      </FileImgPreviewWrapper>
    </>
  );
}

export default FileImgPreview;

const FileImgPreviewWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: flex-end;
  gap: 12px;
`;

const FileDownloadBtn = styled.button.attrs((props) => {})`
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 4px;
  border-radius: 23px;
  border: 1px solid #808991;
  background: #fff;
`;
